
const _commonHeaders = {
    'Content-Type': 'application/json',
};

const FETCH_METHODS = {
    POST: 'POST',
    DELETE: 'DELETE',
    GET: 'GET'
};

/**
 *
 * @param {string} method - fetch protocol
 * @param {string} url - url to call
 * @param {Object} data - body data
 * @param {Object} headers - additional headers to send
 * @return {Promise<boolean|any>} returns JSON result or false if failed call
 */
const makeFetchCall = async (url, data = null, method = FETCH_METHODS.POST, headers = {}, isAlwaysOkayToRespond) => {
    const params = {
        method,
        headers: {
            ..._commonHeaders,
            ...headers
        }
    };

    if(data) {
        params.body = JSON.stringify(data);
    }

    const response = await fetch(url, params);
    if(response.ok || isAlwaysOkayToRespond) {
        return await response.json();
    } else {
        console.error(`Unable to complete fetch | ${url}`, response);
        throw new Error('Unable to complete fetch'); //consumers of makeFetchCall need to handle fallback if response is not good
    }
};

export default makeFetchCall;

export {
    FETCH_METHODS as CommonFetchMethods,
    _commonHeaders as CommonFetchHeaders
};
